import { isEmpty } from "@cat-ecom/common/utils/commonUtils";

export const areEqualArrays = (prevArray: string[], nextArray: string[]) => {
    if (isEmpty(nextArray) || prevArray.length !== nextArray.length ) {
        return false
    }
    for (const index in prevArray) {
        if (prevArray[index] !== nextArray[index]) {
            return false;
        }
    }
    return true;
}